module.exports = __webpack_public_path__ + "img/apartment.0b00035c.svg";